export default "__VITE_ASSET__DhFnmX$l__"